<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	<div [innerHTML]="message"></div>
</mat-dialog-content>

<mat-dialog-actions >
	<div class="w-100 flex-row justify-end items-center mt-3 p-2">
		<a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
	</div>
</mat-dialog-actions>
